import { render, staticRenderFns } from "./CreateСorruption.vue?vue&type=template&id=a8400832&"
import script from "./CreateСorruption.vue?vue&type=script&lang=js&"
export * from "./CreateСorruption.vue?vue&type=script&lang=js&"
import style0 from "./CreateСorruption.vue?vue&type=style&index=0&id=a8400832&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports